import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import RoadsRecorderTable from "./components/RoadsRecorderTable";
import roadsRecorderHistoryStyles from './styles/roadsRecorderHistory.module.css'; 
import RoadPreviewModal from "./components/RoadPreviewModal";
import "../../styles/tabelsPageStyles.css";
import useAuth from "../../hooks/Auth/useAuth";
import { useRoadRecordings } from "../../hooks/useRoadRecordings"; // <-- Import your hook!
import { handleDeleteRecord as deleteRecording } from "./services/handleDeleteRecord";
import { updateRoadRecording } from "./services/updateRoadRecording";

function RoadsRecorderHistory() {
  const { relevantUrl } = useAuth();

  const { records, loading, setRecords, fetchRecords} = useRoadRecordings(relevantUrl);
  const [openPreview, setOpenPreview] = useState(false);
  const [selectedRecording, setSelectedRecording] = useState(null);

  const handleViewRecord = async(recording) => {
    setSelectedRecording(recording);
    setOpenPreview((prev) => !prev);
  };

  const handleDeleteRecord = async (recording) => {deleteRecording(recording, relevantUrl, setRecords);};

  const handleUpdateRecord = async (recordId, updates) => {
    const res = await updateRoadRecording(relevantUrl, recordId, updates);
    if (!res.error) {
      fetchRecords();
      return true;
    } else {
      // Optionally show error
      return false;
    }
  };

  return (
    <div className="bodyContainer">
      <Box className="tableContainer">
        <Box className="header_container">
          <strong className={`header_text ${roadsRecorderHistoryStyles.header_text}`}>
            Road Recorder History
          </strong>
        </Box>
        {loading ? (
          <div style={{ padding: 32, textAlign: "center" }}>Loading...</div>
        ) : (
          <RoadsRecorderTable
            records={records}
            onViewRecord={handleViewRecord}
            onDeleteRecord={handleDeleteRecord}
            onUpdateRecord={handleUpdateRecord}
          />
        )}
      </Box>

      {openPreview && (
        <RoadPreviewModal
          open={openPreview}
          onClose={() => setOpenPreview(false)}
          roadRecording={selectedRecording}
        />
      )}
    </div>
  );
}

export default RoadsRecorderHistory;
